import MuiFormControl from '@mui/material/FormControl';
import type { ComponentPropsWithoutRef, ComponentRef } from 'react';
import { forwardRef } from 'react';

type FormControlProps = ComponentPropsWithoutRef<typeof MuiFormControl>;
type FormControlRef = ComponentRef<typeof MuiFormControl>;
const FormControl = forwardRef<FormControlRef, FormControlProps>(
  (props, ref) => {
    return <MuiFormControl ref={ref} {...props} />;
  },
);
FormControl.displayName = 'FormControl';
export default FormControl;
